import React from 'react';

import { createSafeContext } from '../safe-context';
import { LanguageCodeEnum } from '../saleor-graphql';
import { IChannel } from './types';

interface IChannelContext {
  channel: IChannel;
  saleorLocale?: LanguageCodeEnum;
  locale?: string;
}

const [useChannel, Provider] = createSafeContext<IChannelContext>();

const ChannelProvider = ({
  children,
  ...props
}: IChannelContext & { children: React.ReactNode }) => {
  return <Provider value={{ ...props }}>{children}</Provider>;
};

export { useChannel, ChannelProvider };
